import { CENTRAL_TZ } from "@shared/weeks";

export const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? name;

export const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

/** "Sep 25", in Central. */
export const centralDay = (iso: string) =>
  new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: CENTRAL_TZ });

/**
 * A title short enough for a tab. Four letters or fewer stay as they are; an
 * abbreviation already in the title wins ("Origination BD" is "BD", which is
 * Gray's title); otherwise initials ("Business Development" is "BD").
 */
export function titleBadge(title: string | null | undefined): string | null {
  const t = (title ?? "").trim();
  if (!t) return null;
  if (t.length <= 4) return t;
  const words = t.split(/\s+/);
  const abbreviation = words.find((w) => /^[A-Z]{2,4}$/.test(w));
  if (abbreviation) return abbreviation;
  return words.map((w) => w[0]?.toUpperCase() ?? "").join("");
}

/** "Sep 25 · call". A neutral fact, never a warning. */
export function lastTouchShort(t: { at: string; kind: string } | null): string {
  if (!t) return "—";
  const kind = t.kind === "referral_sent" ? "referral" : t.kind;
  return `${centralDay(t.at)} · ${kind}`;
}

/** Clicking the focused person returns to everyone; clicking anyone else focuses them. */
export function nextWho(current: string, clicked: string): string {
  return clicked === current ? "all" : clicked;
}
